import Swiper from 'swiper'
import {Navigation, Autoplay} from 'swiper/modules'
import loadMoreProducts from "./_load-more-products"
const CURRENT_URL = new URL(window.location.href)

document.addEventListener('DOMContentLoaded', () => {
    const sliderWrappers = document.querySelectorAll('.mtt-product-link-boxes--slider')

    if (sliderWrappers.length > 0) {
        sliderWrappers.forEach(sliderWrapper => {
            const swiperElement = sliderWrapper.querySelector('.mtt-product-link-boxes__content')
            const nextButton = sliderWrapper.querySelector('.swiper-next')
            const prevButton = sliderWrapper.querySelector('.swiper-prev')

            const swiperOptions = {
                modules: [Navigation, Autoplay],
                spaceBetween: 8,
                slidesPerView: 1,
                loop: true,
                grabCursor: true,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton
                },
                breakpoints: {
                    580: {
                        slidesPerView: 2,
                        spaceBetween: 16
                    },
                    900: {
                        slidesPerView: 3,
                        spaceBetween: 16
                    }
                }
            }

            const swiper = new Swiper(swiperElement, swiperOptions)
        })
    }

    loadMoreProducts(CURRENT_URL)
})